// The details panel shared by the customer, salesman and product views.
import { Drawer } from "@mui/material";
import "./DetailPanel.css";

export function PanelHead({ title, subtitle, onClose, closeLabel, headingRef }) {
  return <div className="sa-panel-head">
    <div><h2 ref={headingRef} tabIndex={-1}>{title}</h2>{subtitle && <p>{subtitle}</p>}</div>
    <button type="button" className="sa-panel-close" aria-label={closeLabel} onClick={onClose}>×</button>
  </div>;
}

export default function DetailPanel({ mode = "sheet", label, busy, onClose, children }) {
  if (mode === "split") {
    return <aside className="sa-detail-panel" id="sa-detail-panel" aria-label={label} aria-busy={busy}
      onKeyDown={(event) => { if (event.key === "Escape") onClose?.(); }}>{children}</aside>;
  }
  return <Drawer anchor="right" open onClose={onClose} sx={{ zIndex: 1300 }}
    PaperProps={{ className: "sa-detail-panel sa-detail-panel--sheet", id: "sa-detail-panel", role: "dialog", "aria-label": label, "aria-busy": busy }}>
    {children}
  </Drawer>;
}
